import { create } from 'zustand'

interface CompanyPickerState {
  open: boolean
  /** present only when picker was opened by a 428 interceptor awaiting a choice */
  pendingResolve: (() => void) | null
  openManual: () => void
  openForPending: (resolve: () => void) => void
  close: () => void
  resolvePending: () => void
}

export const useCompanyPicker = create<CompanyPickerState>((set, get) => ({
  open: false,
  pendingResolve: null,

  openManual() {
    set({ open: true })
  },

  openForPending(resolve: () => void) {
    set({ open: true, pendingResolve: resolve })
  },

  close() {
    const { pendingResolve } = get()
    if (pendingResolve) pendingResolve()
    set({ open: false, pendingResolve: null })
  },

  resolvePending() {
    const { pendingResolve } = get()
    if (pendingResolve) pendingResolve()
    set({ open: false, pendingResolve: null })
  },
}))
